<template>
  <div class="videoLayout ">
    <h6 class="noVideoText" v-if="searchVideo == ''">
      No additional material available for current page.
      <br />
      Please browse the document to discover additional audiovisual content.
    </h6>

    <div class="videoList">
      <h3 v-if="searchVideo != ''">Additional material for this page</h3>
      <div
        v-for="(item, i) in searchVideo"
        v-bind:key="i"
        class="videoListItem"
      >
        <div class="btn-group btn-block" role="group">
          <button class="videoPlayDiv btn">
            <span class="playList"></span>{{ item["name"] }}
          </button>
          <button
            @click="showHiddeVideo(i)"
            class="videoButton btn btn-outline-secondary"
          >
            <span class="buttonIcon">&#9658;</span>
            <span class="videoButtonText">Play Video</span>
          </button>

          <button
            class="noteButton btn btn-outline-secondary"
            @click.prevent="downloadNote(item['url-foto'], item['name'])"
          >
            <span class="buttonIcon">&#x21e9;</span>
            <span class="videoButtonText">Download Score</span>
          </button>
        </div>

        <div width="100%" class="videoPlayer" v-if="!searchVideo[i].id">
          <button
            id="closeButton"
            v-if="hideVideoButton"
            @click="showHiddeVideo(i)"
          >
            X
          </button>
          <video width="100%" class="hiddenVideo" controls>
            <source
              v-bind:src="item['url-video']"
              type="video/mp4"
              v-bind:name="item['name']"
            />
          </video>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import $ from "jquery";
import axios from "axios";
// import $ from "jquery";
export default {
  name: "VideoLayout",
  props: {
    pageNum: {
      type: Number,
      required: false,
    },
  },
  data() {
    return {
      searchVideo: [],
      hideVideoButton: false,
      pageNumber: 1,
    };
  },

  methods: {
    parseDataList(dataList) {
      this.searchVideo = [];
      for (let entry of dataList) {
        if (
          entry["page1"] == this.pageNumber ||
          entry["page2"] == this.pageNumber
        ) {
          this.searchVideo.push(entry);
        }
      }
    },

    showHiddeVideo: function(index) {
      this.searchVideo[index].id = !this.searchVideo[index].id;
      if (!this.searchVideo[index].id) {
        this.hideVideoButton = true;
      }
    },
    downloadNote: function(url, name) {
      axios.get(url, { responseType: "blob" }).then((response) => {
        const blob = new Blob([response.data], { type: "image/png" });
        const link = document.createElement("a");
        link.href = URL.createObjectURL(blob);
        link.download = decodeURI(name.replaceAll(".", ""));
        link.click();
        URL.revokeObjectURL(link.href);
      });
    },
  },
  mounted() {
    this.parseDataList(this.$root.$data.dataList);
  },

  watch: {
    pageNum: function() {
      this.pageNumber = this.pageNum;
      this.parseDataList(this.$root.$data.dataList);
    },
    "$root.$data.dataList": function(newDataList) {
      this.parseDataList(newDataList);
    },
  },
};
</script>

<style scoped>
.videoListItem {
  margin-top: 10px;
  margin-bottom: 10px;
}
.noVideoText {
  font-size: 13px;
  line-height: inherit;
}
#closeButton {
  color: white;
  background-color: transparent;
  font-size: 11px;
  font-weight: 900;
  border: none;
  position: absolute;
  right: 10px;
  z-index: 1;
  margin: 5px;
}

.buttonIcon {
  text-decoration: none;
  display: block;
  font-weight: bolder;
}
.noteButton .buttonIcon {
  text-decoration: underline;
}
.playVideo {
  display: block;
  font-weight: bolder;
}
.videoButtonText {
  visibility: hidden;
  width: 170px;
  background-color: #8c8c8c;
  color: #fff;
  text-align: center;
  border-radius: 5px;
  padding: 5px 0;
  position: absolute;
  z-index: 1;
  top: 2px;
  right: 105%;
}

.noteButton:hover .videoButtonText {
  visibility: visible;
}
.videoButton:hover .videoButtonText {
  visibility: visible;
}
.playList {
  font-weight: bold;
  padding-right: 5px;
}
.videoPlayDiv {
  display: flex;
  color: black;
  text-decoration: none;
  border: 1px solid rgba(0, 0, 0, 0.125);
  background-color: transparent;
  text-align: start;
  padding: 8px;
  cursor: auto !important;
  font-size: 13px;
}

.videoButton:hover {
  background-color: rgba(0, 0, 0, 0.25);
}
.videoButton:active {
  background-color: rgba(0, 0, 0, 0.5) !important;
}
.noteButton {
  display: flex;
  color: black;
  text-decoration: none;
  border: 1px solid rgba(0, 0, 0, 0.2);
  background-color: rgba(0, 0, 0, 0.1);
  text-align: start;
  padding: 8px;
  max-width: 10%;
  justify-content: center;
  min-width: 35px;
}
.videoButton {
  display: flex;
  color: black;
  text-decoration: none;
  border: 1px solid rgba(0, 0, 0, 0.2);
  background-color: rgba(0, 0, 0, 0.1);
  text-align: start;
  padding: 8px;
  max-width: 10%;
  justify-content: center;
  min-width: 35px;
}

.noteButton:hover {
  background-color: rgba(0, 0, 0, 0.3);
}
.noteButton:active {
  background-color: rgba(0, 0, 0, 0.5) !important;
}
.videoLayout {
  height: fit-content;
  margin-top: 5px;
  padding: 10px;
  border: 1px solid rgba(0, 0, 0, 0.125);
  border-radius: 0.25rem;
}
.videoLayout h3 {
  font-size: inherit;
  font-weight: bold;
  padding: 5px;
  margin: 0px;
}
h6 {
  margin-bottom: 10px;
  margin-top: 10px;
}

@media (max-width: 1200px) {
  .noVideoText {
    font-size: inherit;
  }
  #closeButton {
    right: 0px;
  }
  .videoPlayer {
    z-index: 1;
    position: absolute;
    margin: 0px 10px 0px 0px;
  }
  .hiddenVideo {
    display: block;
    margin-bottom: -7px;
    box-shadow: 0px 8px 16px 0px rgba(0, 0, 0, 0.2);
  }
  .videoLayout {
    margin: 0px;
    padding: 10px;
  }
  .videoPlayDiv {
    display: flex;
    text-decoration: none;
    border: 1px solid rgba(0, 0, 0, 0.125);
    background-color: transparent;
    text-align: start;
    align-items: center;
    font-size: 15px;
  }

  /* .videoButton {
    display: initial;
  } */
}
@media (max-width: 768px) {
  h6 {
    margin-bottom: 5px;
    margin-top: 5px;
  }
  .noVideoText {
    font-size: 15px;
  }
  .videoPlayDiv {
    font-size: 14px;
    margin: 0;
    padding: 5px;
  }
  .buttonIcon {
    display: block;
    font-weight: bolder;
    font-size: 14px;
  }
  .videoButtonText {
    width: 150px;
    font-size: 13px;
  }
}
@media (max-width: 600px) {
  .noVideoText {
    font-size: 13px;
  }

  .videoLayout h3 {
    font-size: 13px !important;
    margin-bottom: 0px;
  }
  .videoPlayDiv {
    font-size: 12px;
  }

  .videoButtonText {
    width: 130px;
    font-size: 12px;
  }
}
@media (max-width: 414px) {
  .noVideoText {
    font-size: 12px;
  }
  .videoPlayDiv {
    font-size: 11px;
  }

  .videoButtonText {
    width: 110px;
    font-size: 11px;
  }
  #closeButton {
    font-size: 10px;
    margin: 3px;
  }
}
@media (max-width: 319px) {
  .noVideoText {
    font-size: 10px;
  }
  .videoPlayDiv {
    font-size: 10px;
  }
  .videoButton {
    padding: 5px;
  }
  .noteButton {
    padding: 5px;
  }

  .videoButtonText {
    width: 100px;
    font-size: 10px;
  }
}
</style>
